import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPreguntaConfirmacionPlantelByIdService,
  getPreguntasConfirmacionPlantelService,
  togglePreguntaConfirmacionPlantelActiveService,
  updatePreguntaConfirmacionPlantelService,
} from "../../../../services/preguntasConfirmacion/question-confirmation-plantel/Preguntasconfirmacionplantel.service";

export const getPreguntasConfirmacionPlantelThunk = createAsyncThunk(
  "preguntasConfirmacionPlantel/getAll",
  async ({ plantelId, page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getPreguntasConfirmacionPlantelService(
        plantelId,
        page,
        search,
      );
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener preguntas";

      return rejectWithValue(message);
    }
  },
);

export const getPreguntaConfirmacionPlantelByIdThunk = createAsyncThunk(
  "preguntasConfirmacionPlantel/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getPreguntaConfirmacionPlantelByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener pregunta";

      return rejectWithValue(message);
    }
  },
);

export const updatePreguntaConfirmacionPlantelThunk = createAsyncThunk(
  "preguntasConfirmacionPlantel/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updatePreguntaConfirmacionPlantelService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar pregunta";

      return rejectWithValue(message);
    }
  },
);

export const togglePreguntaConfirmacionPlantelActiveThunk = createAsyncThunk(
  "preguntasConfirmacionPlantel/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await togglePreguntaConfirmacionPlantelActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);
